import { render, staticRenderFns } from "./suoritteen-kategoria.vue?vue&type=template&id=42c3e563&scoped=true&"
import script from "./suoritteen-kategoria.vue?vue&type=script&lang=ts&"
export * from "./suoritteen-kategoria.vue?vue&type=script&lang=ts&"
import style0 from "./suoritteen-kategoria.vue?vue&type=style&index=0&id=42c3e563&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c3e563",
  null
  
)

export default component.exports